var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlsxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2,
    fill: "#1D844B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3931 8.31348L2.16966 6.599H3.05944L3.84494 7.73288H3.8658L4.61654 6.599H5.53412L4.29678 8.31348L5.54802 10.0826H4.64435L3.85189 8.90774H3.83104L3.05944 10.0826H2.15576L3.3931 8.31348Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.081 5.19189H6.84565V10.0826H6.081V5.19189Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00318 10.1919C8.59536 10.1919 8.2617 10.1054 8.00218 9.93233C7.74266 9.75474 7.55961 9.52933 7.45302 9.2561L8.13426 8.96239C8.21767 9.14454 8.33353 9.28342 8.48182 9.37905C8.63475 9.47468 8.80854 9.5225 9.00318 9.5225C9.19318 9.5225 9.35306 9.49062 9.48282 9.42687C9.61258 9.35856 9.67746 9.25838 9.67746 9.12632C9.67746 8.99882 9.62185 8.89863 9.51062 8.82577C9.3994 8.75291 9.22794 8.68916 8.99622 8.63452L8.57219 8.53206C8.2895 8.46375 8.05547 8.34308 7.8701 8.17004C7.68473 7.99699 7.59205 7.77842 7.59205 7.5143C7.59205 7.30938 7.65229 7.12951 7.77279 6.97468C7.89791 6.81985 8.06474 6.70146 8.27328 6.61949C8.48182 6.53297 8.7089 6.48971 8.95452 6.48971C9.28355 6.48971 9.57319 6.55574 9.82344 6.6878C10.0737 6.8153 10.2544 7.002 10.3656 7.24791L9.69831 7.53479C9.56392 7.26612 9.3183 7.13179 8.96147 7.13179C8.79 7.13179 8.64634 7.16594 8.53048 7.23424C8.41463 7.30255 8.3567 7.39135 8.3567 7.50064C8.3567 7.60537 8.40072 7.69189 8.48877 7.7602C8.57683 7.82395 8.70658 7.8786 8.87805 7.92413L9.3994 8.05392C9.74697 8.14044 10.0088 8.2725 10.1849 8.45009C10.3656 8.62313 10.456 8.83716 10.456 9.09217C10.456 9.31075 10.3911 9.50428 10.2614 9.67277C10.1362 9.8367 9.96246 9.96421 9.74002 10.0553C9.51758 10.1464 9.27196 10.1919 9.00318 10.1919Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 8.31348L10.7774 6.599H11.6672L12.4527 7.73288H12.4735L13.2243 6.599H14.1419L12.9045 8.31348L14.1558 10.0826H13.2521L12.4596 8.90774H12.4388L11.6672 10.0826H10.7635L12.0008 8.31348Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsxIcon);
export default __webpack_public_path__ + "static/media/xlsxIcon.af6e2748997a4aa6887590f9889f7a3d.svg";
export { ForwardRef as ReactComponent };